import { render } from "./vSlider.vue?vue&type=template&id=cfe359f8&scoped=true"
import script from "./vSlider.vue?vue&type=script&lang=js"
export * from "./vSlider.vue?vue&type=script&lang=js"

import "./vSlider.vue?vue&type=style&index=0&id=cfe359f8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe359f8"]])

export default __exports__